/* eslint-disable @typescript-eslint/no-explicit-any */

import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { GetBatteryListParams } from '../../endpoints/seller/SellerBatteryEndpoints';
import {
  BatteriesManufacturersData,
  BatteryApiResponse,
  BatteryDamageInfoData,
  BatteryImageApiResponse,
  BatteryInfoData,
  BatteryMeasurementsApiResponse,
  BatteryOverviewData,
  BatterySellerData,
  ManufacturerModelsData,
} from '../BatteryInterfaces';
import { BaseResponse } from '../UtilsInterface';

const BuyerBatteryService = {
  // 배터리 리스트 조회
  getBatteryList: async (
    params: GetBatteryListParams
  ): Promise<BatteryApiResponse> => {
    try {
      const url = API_ENDPOINTS.get_battery_buyer_list(params); // 동적으로 URL 생성
      const response = await apiClient.get(url); // URL을 사용하여 GET 요청
      return response.data;
    } catch (error) {
      console.error('배터리 리스트 조회 실패:', error);
      throw error;
    }
  },

  // 배터리 손상 정보 조회
  getBatteryDamageInfo: async (
    batteryId: string
  ): Promise<BaseResponse<BatteryDamageInfoData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_damage_info(batteryId)
      );
      return response.data;
    } catch (error) {
      console.error('배터리 손상 정보 조회 실패:', error);
      throw error;
    }
  },

  // 판매자 정보 조회
  getBatterySellers: async (
    batteryId: string
  ): Promise<BaseResponse<BatterySellerData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_sellers(batteryId)
      );
      return response.data;
    } catch (error) {
      console.error('판매자 정보 조회 실패:', error);
      throw error;
    }
  },

  // 배터리 진단 보고서 요약 조회
  getBatteryOverview: async (
    batteryId: string
  ): Promise<BaseResponse<BatteryOverviewData[]>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_overview(batteryId)
      );
      return response.data;
    } catch (error) {
      console.error('배터리 요약 정보 조회 실패:', error);
      throw error;
    }
  },

  // 배터리 측정 데이터 조회
  getBatteryMeasurements: async (
    batteryId: string,
    page: number,
    size: number,
    category: string
  ): Promise<BatteryMeasurementsApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_measurements(
          batteryId,
          page,
          size,
          category
        )
      );
      return response.data;
    } catch (error) {
      console.error('배터리 측정 데이터 조회 실패:', error);
      throw error;
    }
  },

  // 배터리 상세 정보 조회
  getBatteryInfo: async (
    batteryId: string
  ): Promise<BaseResponse<BatteryInfoData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_info(batteryId)
      );
      return response.data;
    } catch (error) {
      console.error('배터리 상세 정보 조회 실패:', error);
      throw error;
    }
  },

  // 배터리 이미지 조회
  getBatteryImages: async (
    batteryId: string,
    page: number,
    size: number
  ): Promise<BatteryImageApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_images(batteryId, page, size)
      );
      return response.data;
    } catch (error) {
      console.error('배터리 이미지 조회 실패:', error);
      throw error;
    }
  },

  // 연식 데이터 조회
  getBatteryModelsYears: async (
    carModelId: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_models_years(carModelId)
      );
      return response.data;
    } catch (error) {
      console.error('연식 데이터 조회 실패:', error);
      throw error;
    }
  },

  // 제조사 목록 조회
  getBatteryManufacturers: async (): Promise<
    BaseResponse<BatteriesManufacturersData[]>
  > => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_manufacturers()
      );
      return response.data;
    } catch (error) {
      console.error('제조사 목록 조회 실패:', error);
      throw error;
    }
  },

  // 제조사 모델 목록 조회
  getManufacturerModels: async (
    carManufacturerId: string
  ): Promise<BaseResponse<ManufacturerModelsData[]>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_battery_buyer_manufacturer_models(carManufacturerId)
      );
      return response.data;
    } catch (error) {
      console.error('제조사 모델 목록 조회 실패:', error);
      throw error;
    }
  },
};

export default BuyerBatteryService;
